import type { CompleteServiceExecutionFragment } from '@drycut/graphql';

import EmptyState from '../EmptyState';
import QueueTable from '../QueueTable';
import QueuedServiceRow from './QueuedServiceRow';

type Props = {
  services: CompleteServiceExecutionFragment[];
};

export default function QueuedServicesTable({ services }: Props): React.ReactElement {
  if (services.length === 0) {
    return <EmptyState>Keine Buchungen vorhanden.</EmptyState>;
  }

  return (
    <QueueTable.Table>
      <QueueTable.TableHeader>
        <QueueTable.THead className="w-28">Buchung</QueueTable.THead>
        <QueueTable.THead className="w-28">Kunde</QueueTable.THead>
        <QueueTable.THead>Erwartete Zeit</QueueTable.THead>
        <QueueTable.THead>Wartezeit</QueueTable.THead>
        <QueueTable.THead>Pickup</QueueTable.THead>
        <QueueTable.THead>Stylist</QueueTable.THead>
        <QueueTable.THead>Coupon</QueueTable.THead>
        <QueueTable.THead />
      </QueueTable.TableHeader>

      <tbody>
        {services.map((serviceExecution) => (
          <QueuedServiceRow key={serviceExecution.id} serviceExecution={serviceExecution} />
        ))}
      </tbody>
    </QueueTable.Table>
  );
}
